import { Match } from "../types/Match";
import { parseUtcDateTime } from "./timeUtils";

export const MATCH_ALREADY_PLAYED_AFTER_HOURS = 4;
const MATCH_ALREADY_PLAYED_AFTER_MS =
  MATCH_ALREADY_PLAYED_AFTER_HOURS * 60 * 60 * 1000;

export type MatchBettingState = "open" | "locked" | "played";

/**
 * Parses a match kickoff into a Date. The backend stores kickoff as a UTC
 * timestamp without a trailing "Z", so we append it when missing (mirrors the
 * existing logic in BetCard) to avoid the value being read as local time.
 */
export function getMatchKickoff(match?: Match): Date | null {
  const dateTime = match?.kickOffTime?.dateTime;
  if (!dateTime) return null;
  return parseUtcDateTime(dateTime);
}

/**
 * Whether a user may still place/edit a prediction for a match: only before
 * kickoff and while the match has not been played. Single source of truth for
 * the bet sheet/dialog and the fixture tiles' call-to-action.
 */
export function isBettingOpen(match?: Match): boolean {
  return getMatchBettingState(match) === "open";
}

export function getMatchBettingState(
  match?: Match,
  nowMs = Date.now()
): MatchBettingState {
  if (!match) return "locked";
  if (match.wasPlayed) return "played";

  const kickoff = getMatchKickoff(match);
  if (kickoff === null) return "locked";

  const kickoffMs = kickoff.getTime();
  if (kickoffMs > nowMs) return "open";
  if (nowMs >= kickoffMs + MATCH_ALREADY_PLAYED_AFTER_MS) return "played";
  return "locked";
}

export function isMatchAlreadyPlayedForBetting(match?: Match): boolean {
  return getMatchBettingState(match) === "played";
}
